<template>
  <v-container class="footer-container" fluid>
    <v-footer color="white" bottom>
      <v-row>
        <v-col class="text-center text-caption text--secondary " cols="12">
          &copy; CM, Chair of Connected Mobility, Technical University of
          Munich, 2020-{{ new Date().getFullYear() }}
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<style scoped>
.footer-container {
  border-top: 1px solid #d8d8d8;
  margin-top: 1rem;
}
</style>

<script>
export default {
  name: "Footer",
};
</script>
